<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="exportFile"
      @reject="reject"
      @binding="binding"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <div class="drop">
          <el-dropdown
            v-if="allow('I')"
            size="small"
            split-button
            @click="$refs.orderImport.orderImport()"
            @command="importTemplate"
            class="ml-2"
          >
            <b-icon icon="cloud-upload" />
            {{ $l('btn_orderImport') || '订单导入' }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                {{ $l('dropdown_template') || '下载 京东工厂采购订单模板' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <RejectedForm
      :visible.sync="rejectedFormOpts.visible"
      :hxPurchaseCode="rejectedFormOpts.hxPurchaseCode"
      @reload="reload"
    />

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-hx-purchase' }"
      :exportOptions="{
        params: { hxPurchaseCode: chooseTemplateOptions.hxPurchaseCode },
        checkUrl: '/ecom/hx/fty/purchase/checkExport',
      }"
    />

    <OrderImport ref="orderImport" @reload="reload" />

    <ChooseHxPreOrder
      :visible.sync="chooseHxPreOrderOptions.visible"
      :multiple="false"
      confirm-on-close
      reserve
      @confirm="choosePreOrderConfirm"
    />
    <ChooseImportTemplate
      :visible.sync="chooseImportTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-purchaseOrder' }"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import RejectedForm from '../rejected-form'
import chooseTemplate from '@/views/ecom/components/choose-template'
import OrderImport from '../order-import'
import ChooseHxPreOrder from '../choose-hx-pre-order'
import ChooseImportTemplate from '@/views/ecom/components/choose-import-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    RejectedForm,
    chooseTemplate,
    OrderImport,
    ChooseHxPreOrder,
    ChooseImportTemplate,
  },
  data() {
    return {
      usePage: true,
      rejectedFormOpts: { visible: false, hxPurchaseCode: '' },
      chooseTemplateOptions: { visible: false, hxPurchaseCode: '' },
      chooseHxPreOrderOptions: { visible: false, hxPurchaseCode: '' },
      chooseImportTemplateOptions: { visible: false },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxFtyPurchaseListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query }) {
      this.$router.push({
        name: 'ecom-hxBiz-hxFtyPurchaseOrder-detail',
        params: { pageType, ...params },
        query,
      })
    },
    reject({ hxPurchaseCode }) {
      this.rejectedFormOpts = { hxPurchaseCode, visible: true }
    },
    exportFile({ hxPurchaseCode }) {
      this.chooseTemplateOptions = { visible: true, hxPurchaseCode }
    },
    binding({ hxPurchaseCode }) {
      this.chooseHxPreOrderOptions = { visible: true, hxPurchaseCode }
    },
    async choosePreOrderConfirm({ hxPreOrderCode, hxPreOrderNo }) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxFtyPurchaseBindingApi({
          hxPreOrderCode,
          hxPreOrderNo,
          hxPurchaseCode: this.chooseHxPreOrderOptions.hxPurchaseCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('绑定失败！')
        return
      }
      this.$message({
        message: '绑定成功！',
        type: 'success',
      })
      this.reload()
      this.chooseHxPreOrderOptions.visible = false
    },
    importTemplate() {
      this.chooseImportTemplateOptions = {
        visible: true,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .drop {
    .el-button {
      border: 1px solid #28a745;
      color: #28a745;
      font-size: 0.875rem;
      border-radius: 3px 0px 0px 3px !important;
    }
    .el-dropdown__caret-button {
      border-left: none;
      border-radius: 0px 3px 3px 0px !important;
    }
    .el-button:hover {
      color: #fff;
      background-color: #28a745;
      border-color: #28a745;
    }
    .el-button--default::before {
      background: #d0d2d6;
    }
    .el-button--small {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;
    }
  }
}
</style>
